const ArabicContent = {
    companyName: "فيرما ديف",
    companySlogan: "حل إدارة البيانات بدون كود",
    submitLabel: "إرسال",
    startHereLabel: "ابدأ هنا",
    loginHereLabel: "تسجيل الدخول هنا",
    logoutLabel: "تسجيل الخروج",
    generalLabel: "عام",
    backLabel: "رجوع",
    profileLabel: "الملف الشخصي",
    settingsLabel: "الإعدادات",
    integrationsLabel: "التكاملات",
    dashboardLabel: "لوحة التحكم",
    dashboardWelcomeLabel: "مرحباً!",
    reportsLabel: "تقارير",
    reportLabel: "تقرير",
    chartTypeLabel: "نوع المخطط",
    listsLabel: "قوائم",
    contentLabel: "المحتوى",
    relationsLabel: "العلاقات",
    financialsLabel: "المالية",
    continueLabel: "استمرار",
    userNameLabel: "اسم المستخدم",
    passwordLabel: "كلمة المرور",
    nameLabel: "الاسم",
    industryLabel: "الصناعة",
    websiteLabel: "الموقع الإلكتروني",
    linkedinLabel: "رابط لينكدإن",
    facebookLabel: "رابط فيسبوك",
    twitterLabel: "رابط تويتر",
    angelLabel: "رابط Angel",
    crunchbaseLabel: "رابط Crunchbase",
    primaryThemeLabel: "السمة الأساسية",
    openSettingsLabel: "افتح الإعدادات",
    addModelLabel: "إضافة نموذج",
    modelLabel: "نموذج",
    addPoolLabel: "إضافة مجموعة بيانات",
    dashboardNotificationsLabel: "إشعارات المؤسسة",
    notificationsLabel: "الإشعارات",
    emailNotificationsLabel: "إشعارات البريد الإلكتروني",
    emailNotificationsMessage: "إشعارات البريد الإلكتروني قابلة للتخصيص، مما يتيح للمستخدمين اختيار أنواع الإشعارات التي يرغبون في تلقيها وتحديد تفضيلاتهم",
    dailyReportsLabel: "تقارير يومية",
    dailyReportsMessage: "احصل على تقرير مفصل عن نشاط المؤسسة في نهاية اليوم. نستخدم خوارزميات وتقنيات تعلم آلي لجلب أهم تفاصيل نشاط فريقك",
    dealsClosingAlert: "تنبيهات إغلاق الصفقات",
    dealsClosingMessage: "كن أول من يتلقى إشعارًا عند تنفيذ أو إغلاق الصفقات",
    contentDeletionAlert: "تنبيهات حذف المحتوى",
    contentDeletionMessage: "الحفاظ على دقة بياناتك أمر مهم، سيتم إعلامك عند حذف أي أصل أو محتوى من مؤسستك",
    deviceNotificationsLabel: "إشعارات الأجهزة",
    securityUpdatesMessage: "يتم إعلامك فقط عند وجود مخاوف أمنية تتعلق بمؤسستك",
    allUpdatesMessage: "احصل على جميع التحديثات المهمة وابق على اطلاع بجميع المستجدات",
    newPasswordLabel: "كلمة مرور جديدة",
    newChatLabel: "دردشة جديدة",
    aiModelLabel: "نموذج الذكاء الاصطناعي",
    bottomFooterLabel: "تسجيل آمن",
    codeLabel: "الرمز",
    platformLanguageLabel: "لغة المنصة",
    platformCurrencyLabel: "عملة المنصة",
    preferredCurrencyLabel: "العملة المفضلة",
    organizationNameLabel: "اسم المؤسسة",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    confirmationCodeLabel: "رمز التأكيد",
    resetPassLabel: "إعادة تعيين كلمة المرور",
    firstNameLabel: "الاسم الأول",
    lastNameLabel: "اسم العائلة",
    jobTitleLabel: "المسمى الوظيفي",
    emailLabel: "البريد الإلكتروني",
    defaultPassword: "كلمة المرور الافتراضية",
    dobLabel: "تاريخ الميلاد",
    phoneNumberLabel: "رقم الهاتف",
    contentCollageLabel: "إدارة المحتوى",
    relationsCollageLabel: "إدارة العلاقات",
    financialsCollageLabel: "إدارة المالية",
    forgotPassDescription: "هل نسيت كلمة المرور؟",
    codePassDescription: "هل لديك رمز بالفعل؟",
    resetPassDescription: "استرجعها من هنا",
    resetCodeDescription: "أكمل التسجيل هنا",
    backToLoginDescription: "العودة لتسجيل الدخول",
    resendCodeLabel: "إعادة إرسال رمز التأكيد",
    resendCodeDescription: "شكرًا لتسجيلك في فيرما ديف، أدخل بريدك الإلكتروني لإعادة إرسال رمز التأكيد",
    verifyCodeDescription: "إرسال بريد التحقق",
    confirmCodeDescription: "لدي الرمز",
    signupSuccessDescription: "شكرًا لتسجيلك في فيرما ديف. لقد أرسلنا رمز تأكيد إلى بريدك الإلكتروني، يرجى نسخه ولصقه هنا للمتابعة. تأكد من التحقق من مجلد الرسائل غير المرغوب فيها",
    noDataDescription: "لم يتم إنشاء بيانات هنا",
    addSectionLabel: "إضافة قسم",
    invoicePreviewLabel: "معاينة الفاتورة",
    inventoriesLabel: "المخزون",
    exploreLabel: "استكشاف",
    exploreMessage: "باستخدام هذه الميزة، سيتم ربطك بالمؤسسة المطلوبة. هل تود الاستمرار؟",
    invoiceAmountLabel: "إجمالي مبلغ الفاتورة",
    reachOutMessageLabel: "لأي استفسار، يرجى التواصل مع",
    payToLabel: "الدفع إلى",
    viewLabel: "عرض",
    saveLabel: "حفظ",
    saveChangesLabel: "حفظ التغييرات",
    yesLabel: "نعم",
    editLabel: "تعديل",
    closeLabel: "إغلاق",
    cancelLabel: "إلغاء",
    okayLabel: "حسنًا",
    errorLabel: "خطأ",
    downloadCSVLabel: "تحميل CSV",
    downloadPDFLabel: "تحميل PDF",
    newTeamMember: "عضو فريق جديد",
    teamMember: "عضو الفريق",
    subscriptionLabel: "الاشتراك",
    cancelSubscriptionLabel: "إلغاء الاشتراك",
    areYouSureLabel: "هل أنت متأكد!",
    cancelSubscriptionTitle: "هل ترغب في متابعة إلغاء الاشتراك؟",
    cancelSubscriptionDescription: "سيتسبب هذا في إيقاف حسابات جميع أعضاء الفريق. ننصحك، إذا لم تفعل بعد، بإيقاف الاشتراك مؤقتًا حتى تظل قادرًا على الوصول إلى بياناتك",
    cancellationQuestion: "يرجى تحديد سبب الإلغاء",
    thankYouMessage: "شكرًا لاختيارك فيرما ديف لإدارة بياناتك. خصوصيتك وأمان بياناتك على رأس أولوياتنا",
    pauseSubscription: "إيقاف الاشتراك مؤقتًا",
    currentSubscriptionStatus: "حالة الاشتراك الحالية",
    pauseSubscriptionTitle: "هل ترغب في متابعة إيقاف الاشتراك مؤقتًا؟",
    pauseSubscriptionDescription: "إذا تابعت، سنبقي بياناتك آمنة. يمكن تصدير البيانات بسهولة. بعد ذلك، سيتم تعيين جميع الأعضاء إلى وضع العرض فقط، ويمكنك استئناف الاشتراك في أي وقت",
    upgradeLabel: "ترقية",
    upgradeSubscription: "ترقية الاشتراك",
    upgradeSubscriptionTitle: "في فيرما كونسلتنغ، نقدم تجربة تطوير ديناميكية متكاملة تعمل جنبًا إلى جنب مع عمليات أعمالك",
    upgradeSubscriptionDescription: "أمان البيانات يضمن الحفاظ على سرية المعلومات الحساسة ويمنع الوصول غير المصرح به، مثل سرقة الهوية أو الخسارة المالية أو الاحتيال",
    currentStatusLabel: "الحالة الحالية",
    periodEndsLabel: "نهاية الفترة",
    nextBillingLabel: "تاريخ الفاتورة القادمة",
    choosePlanLabel: "اختر خطة",
    selectProductLabel: "اختر المنتج",
    selectModelLabel: "اختر النموذج",
    selectRoleLabel: "اختر الدور",
    selectFrequencyLabel: "اختر التكرار",
    selectChartTypeLabel: "اختر نوع المخطط",
    roleLabel: "الدور",
    frequencyLabel: "التكرار",
    selectOperationLabel: "اختر العملية",
    selectFieldLabel: "اختر الحقل",
    selectCalculationLabel: "اختر الحساب",
    calculationLabel: "الحساب",
    calculationValueLabel: "قيمة الحساب",
    expiresOnLabel: "تنتهي في",
    paymentMethodLabel: "طريقة الدفع",
    billingDetailsLabel: "تفاصيل الفاتورة",
    manageFiltersLabel: "إدارة الفلاتر",
    dataModelNameLabel: "اسم نموذج البيانات",
    filtersLabel: "الفلاتر",
    schemaLabel: "المخطط",
    addSchemaLabel: "إضافة مخطط",
    addOptionLabel: "إضافة خيار",
    inRelationLabel: "في علاقة",
    manageStatTitle: "إدارة الإحصائيات لنموذجك",
    operationLabel: "العملية",
    typeLabel: "النوع",
    searchLabel: "بحث",
    refreshLabel: "تحديث",
    addLabel: "إضافة",
    importLabel: "استيراد",
    exportLabel: "تصدير",
    paymentLabel: "الدفع",
    commentsLabel: "التعليقات",
    addressLabel: "العنوان",
    assetsLabel: "الأصول",
    deleteLabel: "حذف",
    permissionsLabel: "الأذونات",
    streetNumberLabel: "رقم الشارع",
    streetNameLabel: "اسم الشارع",
    cityLabel: "المدينة",
    postalCodeLabel: "الرمز البريدي",
    stateLabel: "الولاية",
    countryLabel: "البلد",
    uploadFileLabel: "رفع ملف",
    addStatLabel: "إضافة إحصائية",
    addParentOrganizationLabel: "إضافة مؤسسة رئيسية",
    addSubOrganizationLabel: "إضافة مؤسسة فرعية",
    addOrganizationLabel: "إضافة مؤسسة",
    parentOrganizationMessage: "يرجى إدخال اسم للمتابعة",
    useDynamicMessage: "استخدم خوارزمية ديناميكية",
    signUpPreMessage: "ليس لديك حساب؟",
    signUpPostMessage: "انضم الآن",
    exportDescription: "ميزة التصدير تتيح لك إنشاء ملف CSV يتم إرساله إلى بريدك الإلكتروني حسب الفلاتر الحالية. قد يستغرق الأمر عدة دقائق حسب حجم البيانات",
    downloadCSVTitle: "تحميل ملف CSV تجريبي",
    downloadCSVDescription: "ارفع ملف CSV تجريبي لاستيراد محتوياتك بشكل جماعي. يرجى اختيار ملف بعد الضغط على إرسال",
    manageDataPoolProperties: "إدارة خصائص مجموعة البيانات",
    manageDataPoolLabel: "إدارة مجموعة البيانات",
    addToListLabel: "إضافة إلى قائمة",
    selectListLabel: "اختر قائمة لإضافة المحتويات",
    schemaDialogTitle: "لم يتم إنشاء مخطط إضافي بعد",
    schemaDialogSecondaryTitle: "ابدأ بإضافة الحقول الجديدة لمجموعة البيانات هنا بسهولة",
    organizationMessage: "حافظ على بياناتك على شبكتنا الآمنة واختر إحدى الخطط التالية. ننصحك بالتواصل مع فريقنا لتطوير حلول مخصصة",
    newOrganizationMessage: "لنقم بإنشاء مؤسسة لإكمال التسجيل",
    deleteHandlingMessage: "عند حذف المحتوى من مجموعة البيانات، سيتم حذفه نهائيًا. هل تود الاستمرار؟",
    errorHandlingMessage: "عذرًا! يبدو أن العملية الأخيرة انتهت بخطأ. يرجى إعادة تسجيل الدخول. تم الإبلاغ عن هذا الحادث",
    signUpLabel: "سجّل هنا",
    upgradeMessage: "تستمتع بفيرما ديف؟ فكر في ترقية حسابك من هنا",
    contentContainer: "إدارة نماذج بيانات محتوى المؤسسة هنا",
    relationsContainer: "إدارة نماذج بيانات علاقات المؤسسة هنا",
    financialsContainer: "إدارة نماذج بيانات مالية المؤسسة هنا",
    listsContainer: "إدارة القوائم الديناميكية/الثابتة هنا",
    reportsContainer: "إدارة تقارير التحليلات هنا",
    settingsContainer: "إدارة إعدادات المستخدم والمؤسسة هنا",
    integrationsContainer: "إدارة التكاملات مع التطبيقات الخارجية هنا",
    addModelMessage: "إضافة نموذج جديد هنا",
    addStatMessage: "إضافة إحصائية ديناميكية جديدة لهذا النموذج",
    searchMessage: "أدخل الاسم للبحث",
    tableView: "عرض مجموعات البيانات بشكل جدول",
    gridView: "عرض مجموعات البيانات بشكل شبكة",
    kanbanView: "عرض مجموعات البيانات بشكل كانبان",
    modelMessage: "إدارة نموذج البيانات هنا",
    filtersMessage: "إدارة فلاتر نموذج البيانات هنا",
    schemasMessage: "إدارة الحقول الخاصة بمخطط النموذج هنا",
    listsMessage: "أضف محتوى إلى قائمة موجودة هنا",
    importMessage: "رفع مستند لاستيراد مجموعات بيانات هنا",
    exportMessage: "استلم رابط تحميل CSV عبر البريد الإلكتروني لهذا النموذج",
    refreshMessage: "تحديث المحتوى إلى حالته الطبيعية هنا",
    addPoolMessage: "إضافة محتوى جديد هنا",
    manageContentMessage: "إدارة المحتوى هنا",
    checkContentMessage: "اضغط لإرسال التحديثات",
    openContentMessage: "اضغط للدخول إلى هذا المحتوى",
    openActionsMessage: "اضغط للوصول إلى المزيد من الخيارات",
    sortMessage: "اضغط للترتيب حسب هذا العمود",
    dragNDropMessage: "اسحب وأسقط البطاقة لتغيير الحالة",
    addListMessage: "أضف هذا المحتوى إلى القائمة هنا",
    navigateBackToLists: "الرجوع إلى القوائم",
    manageReportMessage: "إدارة التقرير هنا",
    addParentOrganization: "إضافة مؤسسة رئيسية للمؤسسة الحالية",
    addSubOrganization: "إضافة مؤسسة فرعية للمؤسسة الحالية",
    currentOrganizationMessage: "المؤسسة الحالية المعينة للاستكشاف في هذه الجلسة",
    permissionMessage: "تبديل لتقييد الوصول لهذه الميزة",
    pdfDownloadMessage: "اضغط لتحميل الملف بصيغة PDF",
    csvDownloadMessage: "اضغط لتحميل الملف بصيغة CSV",
    linkMessage: "اضغط لزيارة الرابط",
    errorMessage: "حدث خطأ!",
    createSuccessMessage: "تم الإنشاء بنجاح!",
    updatedSuccessMessage: "تم التحديث بنجاح!",
    removedSuccessMessage: "تم الحذف بنجاح!",
    exportMutationMessage: "تم إرسال طلب التصدير بنجاح!",
    importMutationMessage: "تم إرسال طلب الاستيراد بنجاح!",
    labelText: "التسمية",
};
export default ArabicContent;
